module.exports = __webpack_public_path__ + "img/mind_skeleton_24.b6d6c71c.png";